import { Outlet } from 'react-router-dom';
import { ThemeToggle } from '@/components/layout';
import styles from './AuthLayout.module.css';

export function AuthLayout() {
  return (
    <div className={styles.layout}>
      {/* Переключатель темы доступен и до входа — там же, где в кабинете. */}
      <div className={styles.theme}>
        <ThemeToggle />
      </div>
      <div className={styles.card}>
        <Outlet />
      </div>
    </div>
  );
}
